const language = window.localStorage.getItem('language');

export const drivingExperience = [
    { value: 1, label: language === 'ar' ? '6-0' : "0-6", block: language === 'ar' ? 'شهر' : "months" },
    { value: 2, label: language === 'ar' ? '12-6' : "6 - 12", block: language === 'ar' ? 'شهر' : "months" },
    { value: 3, label: language === 'ar' ? '2-1' : "1 - 2", block: language === 'ar' ? 'سنة' : "Years" },
    { value: 4, label: language === 'ar' ? 'أكثر من سنتين' : "More than 2", block: language === 'ar' ? '' : "Years" },
]